import { create } from 'zustand';
import { Sheet, SheetFooter, useAutoFocus } from './Sheet';

interface Pending { title: string; text: string; action: string; onConfirm: () => void }
const useConfirmStore = create<{ pending: Pending | null }>(() => ({ pending: null }));

/** Pede confirmação antes de uma ação destrutiva. */
export function confirmAction(p: Pending) { useConfirmStore.setState({ pending: p }); }

export function ConfirmHost() {
  const pending = useConfirmStore(s => s.pending);
  if (!pending) return null;
  return <ConfirmSheet p={pending} close={() => useConfirmStore.setState({ pending: null })} />;
}

function ConfirmSheet({ p, close }: { p: Pending; close: () => void }) {
  const ok = useAutoFocus<HTMLButtonElement>();
  return (
    <Sheet onClose={close} label={p.title}>
      <div className="sh-body"><h2>{p.title}</h2><p style={{ margin: 0 }} className="muted">{p.text}</p></div>
      <SheetFooter>
        <span className="grow" />
        <button className="btn" onClick={close}>Cancelar</button>
        <button className="btn danger" ref={ok} onClick={() => { p.onConfirm(); close(); }}>{p.action}</button>
      </SheetFooter>
    </Sheet>
  );
}
